module.exports = __webpack_public_path__ + "img/login.687383da.jpg";